import React from 'react';

import { SvgIcon, SvgIconProps } from '@mui/material';

const AltArrowRightLine: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.51192 4.43056C8.82641 4.16099 9.29989 4.19741 9.56946 4.5119L15.5695 11.5119C15.8102 11.7928 15.8102 12.2072 15.5695 12.4881L9.56946 19.4881C9.29989 19.8026 8.82641 19.839 8.51192 19.5694C8.19743 19.2999 8.161 18.8264 8.43057 18.5119L14.0122 12L8.43057 5.48809C8.161 5.1736 8.19743 4.70012 8.51192 4.43056Z"
      />
    </SvgIcon>
  );
};

export default AltArrowRightLine;
